export default "__VITE_ASSET__4acd1581__"